// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".experience-slider .slick-arrow{position:absolute;bottom:.4rem;right:0;width:6rem;z-index:20}.experience-slider .slick-arrow.slick-prev{right:7rem}.experience-slider .slick-dots{width:auto;left:0;top:0;bottom:auto;padding:.75rem 0}.experience-slider .slick-dots li{margin:0 .5rem .5rem}.experience-slider .slick-dots button{width:.75rem;height:.75rem;border:1px solid #fff;background-color:transparent}", ""]);
// Exports
module.exports = exports;
